import { Directive, input } from '@angular/core';
@Directive({
  selector: '[miqStopKeydown]',
  host: {
    '(keydown)': 'onKeydown($event)',
  },
})
export class StopKeydownDirective {
  preventDefault = input(false);
  onKeydown(e) {
    if (this.preventDefault()) {
      e.preventDefault();
    } else {
      e.stopPropagation();
    }
  }
}
